import React, { useState } from 'react'
import Content from './../Services/content'
import './styles.css'
import { Link, useStaticQuery, graphql } from 'gatsby'
import { Menu, X } from 'react-feather'

const NavigationBarPreview = ({ logo }) => {
  const [active, setaActive] = useState(false)
  const {
    dane,
    mzdy,
    zahranici,
    firemniPoradenstvi,
    ucetnictvi,
    znaleckePosudky
  } = Content
  return (
    <header>
      <div className="container-Nav">
        <nav className={active ? 'active' : ''}>
          <div onClick={() => setaActive(!active)} className="menu-icons">
            <X className="ion-md-close" />
            <Menu className="ion-md-menu" />
          </div>
          <Link to="/">
            <img className="logo" src={logo.fluid.src} />
          </Link>
          <ul className="nav-list">
            <li className="move-left">
              <div className="btn">
                <Link className="black-button" to="#">
                  info@ekp.cz
                </Link>
              </div>

              <div className="btn">
                <Link className="black-button" to="#">
                  +420 273 139 330
                </Link>
              </div>
            </li>
            <li>
              <Link className="uppercase" to="/sluzby/">
                Služby
                <i className="icon ion-md-arrow-dropdown"></i>
              </Link>
              <ul className="sub-menu">
                <li>
                  <Link to={`/sluzby/${dane.slug}`}>
                    {dane.title}
                    <i className="icon ion-md-arrow-dropdown"></i>
                  </Link>
                  <ul className="sub-menu">
                    {dane.links.map(item => (
                      <li key={item.slug}>
                        <Link to={`/sluzby/${dane.slug + item.slug}`}>
                          {item.name}
                        </Link>
                      </li>
                    ))}
                  </ul>
                </li>
                <li>
                  <Link to={`/sluzby/${mzdy.slug}`}>
                    {mzdy.title}
                    <i className="icon ion-md-arrow-dropdown"></i>
                  </Link>
                </li>
                <li>
                  <Link to={`/sluzby/${zahranici.slug}`}>
                    {zahranici.title}
                    <i className="icon ion-md-arrow-dropdown"></i>
                  </Link>
                </li>
                <li>
                  <Link to={`/sluzby/${firemniPoradenstvi.slug}`}>
                    {firemniPoradenstvi.title}
                    <i className="icon ion-md-arrow-dropdown"></i>
                  </Link>
                </li>
                <li>
                  <Link to={`/sluzby/${ucetnictvi.slug}`}>
                    {ucetnictvi.title}
                    <i className="icon ion-md-arrow-dropdown"></i>
                  </Link>
                </li>
                <li>
                  <Link to={`/sluzby/${znaleckePosudky.slug}`}>
                    {znaleckePosudky.title}
                    <i className="icon ion-md-arrow-dropdown"></i>
                  </Link>
                </li>
              </ul>
            </li>
            <li>
              <Link className="uppercase" to="#">
                O nás
              </Link>
            </li>
            <li>
              <Link className="uppercase" to="#">
                Kariéra
              </Link>
            </li>
            <li>
              <Link className="uppercase" to="#">
                Novinky a blog
              </Link>
            </li>
            <li>
              <Link className="uppercase" to="#">
                Kontakt
              </Link>
            </li>
            <li>
              <div className="move-top">
                <div className="btn-small">
                  <Link className="black-button" to="#">
                    info@ekp.cz
                  </Link>
                </div>
              </div>
              <div className="move-top">
                <div className="btn-small">
                  <Link className="black-button" to="#">
                    +420 273 139 330
                  </Link>
                </div>
              </div>
            </li>
          </ul>
        </nav>
      </div>
    </header>
  )
}

const NavigationBar = () => {
  const { logo } = useStaticQuery(graphql`
    query {
      logo: file(relativePath: { eq: "hp-logo.png" }) {
        childImageSharp {
          fluid(quality: 100) {
            src
          }
        }
      }
    }
  `)

  return <NavigationBarPreview logo={logo.childImageSharp} />
}

export default NavigationBar
